// extracted by mini-css-extract-plugin
module.exports = {"alternativeGroup":"style-module_alternativeGroup__eyZCICZakq5U4GObq8aGr"};